import { render, staticRenderFns } from "./RuleCategory.vue?vue&type=template&id=622b3310&scoped=true&"
import script from "./RuleCategory.vue?vue&type=script&lang=js&"
export * from "./RuleCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622b3310",
  null
  
)

export default component.exports